var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_chevron-down",
    "data-name": "Icon / chevron-down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8.688,
    viewBox: "0 0 16 8.688",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M15.874.381,15.619.126a.431.431,0,0,0-.61,0L8,7.138.991.126a.431.431,0,0,0-.61,0L.126.381a.431.431,0,0,0,0,.61L7.694,8.561a.431.431,0,0,0,.61,0L15.87.991A.428.428,0,0,0,15.874.381Z",
    transform: "translate(16 8.688) rotate(180)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - chevron-down.64e78a4307a3d1bd8be9ec2b1df46e94.svg";